import * as React from "react"
import {Grid} from "@mui/material";

import MarketplacesProductDetailsEvolutionSkuAutocomplete from "./Autocomplete";
import MarketplacesProductDetailsEvolutionSkuInfo from "./Info";
import MarketplacesProductDetailsEvolutionSkuPaginator from "./Paginator";


export default function MarketplacesProductDetailsEvolutionSkuBlock() {
    return <Grid container spacing={1}>
		<Grid item xs={12}>
			<MarketplacesProductDetailsEvolutionSkuAutocomplete />
		</Grid>

		<Grid item xs={12}>
			<MarketplacesProductDetailsEvolutionSkuInfo />
		</Grid>

		<Grid item xs={12}>
			<MarketplacesProductDetailsEvolutionSkuPaginator />
		</Grid>
    </Grid>
}